import React, { useState, useEffect, useContext } from 'react';
import { useRouteMatch } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { AuthContext } from '../../commons/auth/AuthContext';
import {
    createInvoiceTaxDocumentDigitalSignatureContract,
    getInvoiceTaxDocumentDigitalSignatureContract,
    getInvoiceTaxDocumentDigitalSignatureSigningUrl,
} from '../invoicingRoutes';
import { SIGN_STATUS } from '../../commons/digitalSignature/DigitalSignatureStatus';
import {
    SignStatusCheck,
    SignWithAdobeSignButton,
    DocumentSignedButton,
} from '../../commons/digitalSignature/DigitalSignatureComponents';
import AdobeSignRedirectDisclaimer from '../../commons/digitalSignature/AdobeSignRedirectDisclaimer';

const SubmitTaxDocumentViaDigitalSignatureButton = (props) => {
    const routeMatch = useRouteMatch();
    const { url } = routeMatch.params;

    const { taxDocumentLabel, handleBeforeAdobeSign } = props;

    const authContext = useContext(AuthContext);
    const [invoiceSignStatus, setInvoiceSignStatus] = useState(
        SIGN_STATUS.CHECKING
    );

    useEffect(() => {
        getInvoiceTaxDocumentDigitalSignatureContract(url, authContext).then(
            (res) => {
                const status = _.get(res.data, 'status', SIGN_STATUS.UNSIGNED);
                setInvoiceSignStatus(status);
                // updating the field value to account for centralized form fields validation
                props.onStatusChange(status);
            }
        );
    }, []);

    let subHeaderText = `Please fill ${taxDocumentLabel} using Adobe Sign to continue`;
    let ButtonComponent;
    switch (invoiceSignStatus) {
        case SIGN_STATUS.CHECKING:
            ButtonComponent = (
                <SignStatusCheck statusMessage="Checking Submission status" />
            );
            break;
        case SIGN_STATUS.SIGNED:
            ButtonComponent = (
                <DocumentSignedButton message="Successfully Filled" />
            );
            subHeaderText = `You have successfully filled the ${taxDocumentLabel} using Adobe Sign`;
            break;
        default:
            ButtonComponent = (
                <SignWithAdobeSignButton
                    overlay={
                        <AdobeSignRedirectDisclaimer
                            createContract={
                                createInvoiceTaxDocumentDigitalSignatureContract
                            }
                            getSigningUrl={
                                getInvoiceTaxDocumentDigitalSignatureSigningUrl
                            }
                            message={`You will be taken to Adobe Sign platform to fill and digitally sign the ${taxDocumentLabel}. After successfully signing, you will be redirected back to the ICP Invoicing Application to complete the process.`}
                        />
                    }
                    handleBeforeAdobeSign={handleBeforeAdobeSign}
                    popupHeader={`Fill using Adobe Sign`}
                    buttonText={`Fill using Adobe Sign`}
                />
            );
    }

    return (
        <div className="md:grid md:grid-cols-3">
            <div className="justify-self-start col-span-2">
                <div className="font-bold text-base">
                    Fill {taxDocumentLabel}
                </div>
                <div className="text-gray-500">{subHeaderText}</div>
            </div>
            <div className="flex items-center justify-center md:justify-self-end mt-2 md:mt-1 md:ml-20 md:w-3/5 md:w-max">
                {ButtonComponent}
            </div>
        </div>
    );
};

SubmitTaxDocumentViaDigitalSignatureButton.propTypes = {
    onStatusChange: PropTypes.func,
    taxDocumentLabel: PropTypes.string,
    handleBeforeAdobeSign: PropTypes.func,
};

export { SubmitTaxDocumentViaDigitalSignatureButton };
